import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import MarkEmailReadOutlined from "@mui/icons-material/MarkEmailReadOutlined";

function CheckEmailView() {
  const navigate = useNavigate();
  const location = useLocation();
  const { slug } = useParams();

  const { email = "", redirect = "" } = location.state || {};

  // The destination can itself carry a query (the Bookings tab a reminder claim
  // returns to), so it has to be encoded rather than pasted into the link.
  const goToSignIn = () => navigate(`/${slug}/login${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ""}`, { replace: true });

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh" p={3}>
      <Card sx={{ maxWidth: "32.5rem", width: "100%" }}>
        <CardContent sx={{ p: { xs: 2.5, sm: 4 }, textAlign: "center", "&:last-child": { pb: { xs: 2.5, sm: 4 } } }}>
          <MarkEmailReadOutlined color="primary" sx={{ fontSize: "3.5rem", mb: 1 }} />
          <Typography variant="h5" fontWeight={600} gutterBottom>
            Check your email
          </Typography>
          <Typography variant="body2" color="textSecondary" mb={1}>
            We've sent a verification link to{email ? "" : " your email address"}
          </Typography>
          {email && (
            <Typography variant="body1" fontWeight={600} mb={2}>
              {email}
            </Typography>
          )}
          <Typography variant="body2" color="textSecondary" mb={3}>
            Open it to verify your account, then sign in. The link may take a minute to arrive — remember to check your spam folder.
          </Typography>
          <Button variant="contained" fullWidth size="large" onClick={goToSignIn}>
            Go to sign in
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}

export default CheckEmailView;
